import Swiper from 'swiper'
import { A11y, Autoplay, Navigation, Pagination } from 'swiper/modules'

function createSwiper (container, options) {
    const swiper = new Swiper(container, {
        ...options,
        modules: [A11y, Autoplay, Navigation, Pagination],
    });

    return swiper;
}

globalThis.hl_createSwiper = createSwiper;
